import { render, staticRenderFns } from "./SimpleCardWithTable.vue?vue&type=template&id=47b9d0e8&scoped=true&"
import script from "./SimpleCardWithTable.vue?vue&type=script&lang=ts&"
export * from "./SimpleCardWithTable.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCardWithTable.vue?vue&type=style&index=0&id=47b9d0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9d0e8",
  null
  
)

export default component.exports